import React from "react";
import { AuthContext } from "../interfaces";
export var useAuth = function () {
    var context = React.useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth have to use in the AuthProvider");
    }
    return context;
};
